module.exports = __webpack_public_path__ + "static/02.c2d55bed.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/carousel/02.mp4
// module id = 986
// module chunks = 35783957827783